export default
function home(state = {
  poets: []
}, action) {
  switch(action.type) {
    case 'FETCH_HOME_POETS':
      return Object.assign({}, state, {
        poets: action.homePoets
      });
    case 'FETCH_POET':
      return Object.assign({}, state, {
        poet: action.poet
      });
    case 'FETCH_ALL_POETS':
      return Object.assign({}, state, {
        allPoets: action.allPoets
      });
    case 'UNMOUNT_POET':
      return Object.assign({}, state, {
        poet: null
      });
    case 'FETCH_USER':
      return Object.assign({}, state, {
        user: action.user || false
      });
    default:
      return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/home.js